var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_581_11768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 17C2 8.16344 9.16344 1 18 1C26.8366 1 34 8.16344 34 17C34 25.8366 26.8366 33 18 33C9.16344 33 2 25.8366 2 17Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17C2.5 8.43959 9.43959 1.5 18 1.5C26.5604 1.5 33.5 8.43959 33.5 17C33.5 25.5604 26.5604 32.5 18 32.5C9.43959 32.5 2.5 25.5604 2.5 17Z",
    stroke: "#DCDCDC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4812 16.5194C15.3874 16.6131 15.3346 16.7402 15.3345 16.8728V17.1261C15.3361 17.2584 15.3886 17.385 15.4812 17.4794L18.9079 20.8994C18.9704 20.9626 19.0556 20.998 19.1445 20.998C19.2334 20.998 19.3186 20.9626 19.3812 20.8994L19.8545 20.4261C19.9172 20.3647 19.9526 20.2806 19.9526 20.1928C19.9526 20.105 19.9172 20.0209 19.8545 19.9594L16.8879 16.9994L19.8545 14.0394C19.9176 13.9769 19.9531 13.8917 19.9531 13.8028C19.9531 13.7139 19.9176 13.6287 19.8545 13.5661L19.3812 13.0994C19.3186 13.0363 19.2334 13.0008 19.1445 13.0008C19.0556 13.0008 18.9704 13.0363 18.9079 13.0994L15.4812 16.5194Z",
    fill: "#0A0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_581_11768",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_581_11768"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_581_11768",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButtonIcon);
export default __webpack_public_path__ + "static/media/BackButtonIcon.7210e6762d7dba2cb7d8544833c80795.svg";
export { ForwardRef as ReactComponent };